
import React, { useEffect} from 'react'
import './index.scss'

export interface AiButtonProps {
    disable?:boolean
    loading?:boolean
    text?: React.ReactNode | string // 右上角的图标
    children?:React.ReactNode | string // 右上角的图标
    onClick?:() => void
    technical?:boolean //是否固定在底部  需要弄出位置给  技术提供显示
    technicalBg?:string //底部技术提供显示的背景颜色
    appendPadding?:string
}

const AiButton: React.FC<AiButtonProps> = ({technicalBg = '', disable = false, loading = false, text = '', technical = false, appendPadding = '',  ...props}) => {
    const handleClick = () => {
        if( disable || loading) {
            return
        }
        if(props?.onClick) {
            props?.onClick()
        }
    }
    const handleLoad = () => {
        if( document.getElementById("technical") ) {
            if( technical ) {
                document.getElementById("technical").style.paddingBottom = `calc(1.28rem + ${appendPadding})`
                document.getElementById("app").style.minHeight = `calc(100vh - 2.56rem - ${appendPadding})`
            }
            if( technicalBg ) {
                document.getElementById("technical").style.background = technicalBg
            }
        }
    }
    useEffect(() => {
        if( document.getElementById("technical") ) {
            if( technical ) {
                document.getElementById("technical").style.paddingBottom = `calc(1.28rem + ${appendPadding})`
                document.getElementById("app").style.minHeight = `calc(100vh - 2.56rem - ${appendPadding})`
            }
            if( technicalBg ) {
                document.getElementById("technical").style.background = technicalBg
            }
        }else {
            window.addEventListener("load", handleLoad)
        }
        return () => {
            if( technical && document.getElementById("technical") ) {
                document.getElementById("technical").style.paddingBottom = '0'
                document.getElementById("app").style.minHeight = 'calc(100vh - 1.28rem)'
            }
            if( document.getElementById("technical") ) {
                document.getElementById("technical").style.background = ''
            }
            if( technical ) {
                window.removeEventListener("load", handleLoad)
            }
        }
    },[])
    return (
        <div className={`ai-buton-wrapper ${disable ? 'disable' : ''}`} onClick={handleClick}>{loading && <i className='a-modal-wrapper-loading'></i>}{text || props?.children}</div>
    )
}

export default AiButton

